/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sdh_Formatting_HeadingInputs */



/**
* | output |
* | --- |
* | "Formatting" |
*
* @param {Sdh_Formatting_HeadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const sdh_formatting_heading = /** @type {((inputs?: Sdh_Formatting_HeadingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sdh_Formatting_HeadingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mise en forme")
	if (locale === "de") return /** @type {LocalizedString} */ ("Formatierung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Formattazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Форматирование")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formato")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("格式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("書式")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ॉर्मेटिंग")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formatação")
	return /** @type {LocalizedString} */ ("Formatting")
});